import * as React from 'react';
import { useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import downarrow from 'header/header/srchinput/icon-down-arrow.svg';
import useOutsideClick from 'hooks/useOutsideClick';
import { ListItem } from 'mainpage/knowledgebase/dropdownround/ListItem';
import { KV } from 'models/IfKV';
import { BRKS, STYLS } from 'util/variables';
import { SrchType } from 'mainpage/toparea/srchinput/useZstdSrch';

type Props = {
  label: string;
  kvs: KV<SrchType, string>[];
  width?: string;
  listStyle?: React.CSSProperties;
  mobile?: boolean;
  sels: KV<SrchType, string>[];
  onChange: (e: KV<SrchType, string>) => void;
};
export const DropDown = ({ label, kvs, width, listStyle, sels, onChange, mobile }: Props) => {
  const [showList, setShowList] = useState(false);
  const handleClick = () => {
    setShowList(!showList);
  };

  const ref = useRef();
  const refBtn = useRef();

  useOutsideClick(
    [ref, refBtn],
    () => {
      setShowList(false);
    },
    []
  );

  return (
    <Body>
      <Btn onClick={handleClick} ref={refBtn} $round={mobile}>
        <span style={{ flexGrow: 1 }} className="inline-block">
          {label}
        </span>
        <img src={downarrow} />
      </Btn>
      {showList && (
        <List ref={ref} style={{ width, ...listStyle }}>
          {kvs.map((ele) => (
            <ListItem
              key={ele.key}
              kv={ele}
              onClick={() => {
                setShowList(false);
                onChange(ele);
              }}
              sel={!!sels.find((e) => e.key === ele.key)}
            />
          ))}
        </List>
      )}
    </Body>
  );
};

const List = styled.div`
  min-width: 10rem;
  min-height: 5rem;
  position: absolute;
  box-shadow: ${STYLS.boxShadow};
  background-color: white;
  z-index: 2;
  font-size: 1.4rem;
  border-radius: 0.8rem;
  border: 1px solid #e5e5e5;
  display: flex;
  flex-direction: column;
  padding: 0.4rem;
`;

const Btn = styled.div<{ $round?: boolean }>`
  color: #191a1c;
  font-size: 1.4rem;
  padding: 0.65rem 0.8rem 0.65rem 1.2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  & > span {
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  & img {
    margin-left: 0.4rem;

    @media screen and (max-width: ${BRKS.mobileMax}) {
      margin-left: 0.8rem;
    }
  }
  ${(props) =>
    props.$round &&
    css`
      border-radius: 2rem;
      border: 1px solid #e5e5e5;
    `};
`;

const Body = styled.div`
  width: 100%;
  padding: 0.4rem;
  position: relative;

  @media screen and (max-width: ${BRKS.mobileMax}) {
    width: auto;
  }
`;
